import { boronClient } from "../../../api";
import { AiAssistantTemplateFormValues } from "../../../components/features/AiAssistantTemplateForm/validationSchema";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useAiAssistantTemplatesCacheUpdater } from "../../SectionsSettingsAiAssistantTemplatesPage/useFetchAiAssistantTemplates";
import { useAiAssistantTemplateCacheUpdater } from "./useFetchAiAssistantTemplate";

export const useUpdateAiAssistantTemplate = ({
  sectionId,
  templateId,
}: {
  sectionId: string;
  templateId: string;
}) => {
  const { updateAiAssistantTemplate: updateListCache } =
    useAiAssistantTemplatesCacheUpdater();
  const { updateAiAssistantTemplate: updateDetailCache } =
    useAiAssistantTemplateCacheUpdater();

  return useBoronMutation(
    async (values: AiAssistantTemplateFormValues) =>
      await boronClient.PATCH(
        "/api/v1/sections/{section_id}/ai_assistant_templates/{id}",
        {
          params: {
            path: {
              section_id: sectionId,
              id: Number(templateId),
            },
          },
          body: { ai_assistant_template: values },
        },
      ),
    {
      onSuccess: ({ aiAssistantTemplate }) => {
        updateListCache(sectionId, aiAssistantTemplate);
        updateDetailCache(sectionId, aiAssistantTemplate);
      },
    },
  );
};
